export class State {
    constructor(public code: string, public name: string) {}
}
